<template>
    <div v-if="paymentDiscount?.Amount < 0" class="price-section">
        <PriceSpecificationRow :price="paymentDiscount" :description="description" />
        <Divider color="lightGrey" bottomMargin="xl" topMargin="xl" thickness="1" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Money } from '@libs/money/money.interfaces';
    import PriceSpecificationRow from '../PriceSpecificationRow.vue';
    import Divider from '@ui/components/Divider/Divider.vue';

    export default defineComponent({
        name: 'PriceSpecificationPaymentDiscount',
        components: {
            Divider,
            PriceSpecificationRow,
        },
        props: {
            discount: {
                type: Object as PropType<Money>,
                required: true,
            },
            description: {
                type: String,
                required: true,
            },
        },
        computed: {
            paymentDiscount(): Money {
                return this.discount?.Amount
                    ? { ...this.discount, Amount: this.discount.Amount * -1 }
                    : this.discount;
            },
        },
    });
</script>
